import axios from '@/libs/axios'
const url =     'https://api.pagwise.com/';        // "https://api.pagwise.com/"  //http://localhost:3000/
export default {
  namespaced: true,
  actions: {

  async getContasBancarias(context,value){

      const AuthStr = 'Bearer ' + JSON.parse(localStorage.getItem('token_wise'))
      return new Promise((resolve, reject) => {
                return axios.get(url + "api/v1/bank-accounts/"+value,{
                        headers: {
                            'Authorization': AuthStr,
                            'Content-Type': 'application/json',
                        },
                    })
                  .then(({ data }) => {
                     
                        context.commit('SET_CONTAS_ESTABELECIMENTO', data.data)
                       
                        resolve(data);
                    })
                    .catch(error => {
                        // console.log(error)
                        reject(error)
                    });
            });
  
  
  },

  async listarTransacao(context, value) {

    const AuthStr = 'Bearer ' + JSON.parse(localStorage.getItem('token_wise'))
      return new Promise((resolve, reject) => {
                return axios.get(url + "api/v1/bank-transactions/"+value,{
                        headers: {
                            'Authorization': AuthStr,
                            'Content-Type': 'application/json',
                        },
                    })
                  .then(({ data }) => {
                     
                    context.commit('SET_LISTA_ENVIOS', data.data)
                       
                        resolve(data);
                    })
                    .catch(error => {
                        // console.log(error)
                        reject(error)
                    });
            });
    
    
  

  },
  
  async saldoEstabelecimento(context,value){

    const AuthStr = 'Bearer ' + JSON.parse(localStorage.getItem('token_wise'))
    return new Promise((resolve, reject) => {
              return axios.get(url + "api/v1/balance/"+value.id+"/balance",{
                      headers: {
                          'Authorization': AuthStr,
                          'Content-Type': 'application/json',
                      },
                  })
                .then(({ data }) => {
                   
                      context.commit('SET_SALDO_ESTABELECIMENTO', data.data.balance)
                     
                      resolve(data);
                  })
                  .catch(error => {
                      // console.log(error)
                      reject(error)
                  });
          });


  },
  async saldoEmpresa(context,value){

    const AuthStr = 'Bearer ' + JSON.parse(localStorage.getItem('token_wise'))
    return new Promise((resolve, reject) => {
              return axios.get(url + "api/v1/company/"+ JSON.parse(localStorage.getItem('user_wise')).companyId +"/balance",{
                      headers: {
                          'Authorization': AuthStr,
                          'Content-Type': 'application/json',
                      },
                  })
                .then(({ data }) => {
                   
                      context.commit('SET_SALDO_EMPRESA', data.data.balance)
                     
                      resolve(data);
                  })
                  .catch(error => {
                      // console.log(error)
                      reject(error)
                  });
          });


  },

  async saldoHoje(context,value){
    var date = new Date();
    const currentYear = date.getFullYear();
    const today = date.getDate();
    
    const currentMonth = date.getMonth() + 1; 
    const inicio_data = currentYear +"-"+ currentMonth + "-" + today
    const fim_data = currentYear +"-"+ currentMonth + "-" + today
    
    const AuthStr = 'Bearer ' + JSON.parse(localStorage.getItem('token_wise'))
    return new Promise((resolve, reject) => {
              return axios.get(url + "api/v1/company/"+ JSON.parse(localStorage.getItem('user_wise')).companyId + "/balanceday/" + inicio_data + "/" + fim_data,{
                      headers: {
                          'Authorization': AuthStr,
                          'Content-Type': 'application/json',
                      },
                  })
                .then(({ data }) => {
                   
                      context.commit('SET_SALDO_HOJE', data.data.balance)
                     
                      resolve(data);
                  })
                  .catch(error => {
                      // console.log(error)
                      reject(error)
                  });
          });


  },

  async saldoMes(context,value){

    var date = new Date();
    var primeiroDia = new Date(date.getFullYear(), date.getMonth(), 1).getDate()
    var ultimoDia = new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate();
    const currentYear = date.getFullYear();
    const currentMonth = date.getMonth() + 1; 
    const inicio_data = currentYear +"-"+ currentMonth + "-"+ primeiroDia
    const fim_data = currentYear +"-"+ currentMonth + "-" + ultimoDia

    
    const AuthStr = 'Bearer ' + JSON.parse(localStorage.getItem('token_wise'))
    return new Promise((resolve, reject) => {
              return axios.get(url + "api/v1/company/"+ JSON.parse(localStorage.getItem('user_wise')).companyId +"/balanceday/"+ inicio_data +"/"+ fim_data,{
                      headers: {
                          'Authorization': AuthStr,
                          'Content-Type': 'application/json',
                      },
                  })
                .then(({ data }) => {
                   
                      context.commit('SET_SALDO_MES', data.data.balance)
                     
                      resolve(data);
                  })
                  .catch(error => {
                      // console.log(error)
                      reject(error)
                  });
          });

  },

  async solicitarTransferencia(context, value) {
    const AuthStr = 'Bearer ' + JSON.parse(localStorage.getItem('token_wise'))
    return new Promise((resolve, reject) => {
            
              return axios.post(url + "api/v1/bank-transactions", value,{
                      headers: {
                          'Authorization': AuthStr,
                          'Content-Type': 'application/json',
                      },
                  })
                .then(({ data }) => {
                     console.log(data)
                      // context.commit('SET_USER', data.data.user)

                      resolve(data);
                  })
                  .catch(error => {
                      console.log(error)
                      reject(error)
                  });
          });


  },
 
  async all_estabelecimentos(context) {

      const AuthStr = 'Bearer ' + JSON.parse(localStorage.getItem('token_wise'))
     
      await axios.get(url + "api/v1/establishments", {
              headers: {
                  'Authorization': AuthStr,
                  'Content-Type': 'application/json',
              },
          })
          .then(response => {
            // console.log(response.data)
              context.commit('SET_ESTABELECIMENTOS', response.data)


          })
          .catch((error) => {
              console.log(error.response.data.message)
          }).finally(() => {
              //   context.commit('PRELOADER_MUDAR', false)
          })
  },

  async cadastrar(context, value) {
    const AuthStr = 'Bearer ' + JSON.parse(localStorage.getItem('token_wise'))
    return new Promise((resolve, reject) => {
            
              return axios.post(url + "api/v1/establishments", value,{
                      headers: {
                          'Authorization': AuthStr,
                          'Content-Type': 'application/json',
                      },
                  })
                .then(({ data }) => {
                     console.log(data)
                      // context.commit('SET_USER', data.data.user)

                      resolve(data);
                  })
                  .catch(error => {
                      console.log(error)
                      reject(error)
                  });
          });


  },

  async get_estabelecimento(context, value) {
    const AuthStr = 'Bearer ' + JSON.parse(localStorage.getItem('token_wise'))
    return new Promise((resolve, reject) => {
            
              return axios.get(url + "api/v1/establishments/get/"+value.id,{
                      headers: {
                          'Authorization': AuthStr,
                          'Content-Type': 'application/json',
                      },
                  })
                .then(({ data }) => {
                  
                  data.data['fees'] = value.fees
                  console.log(value)
                        console.log(data.data)
                      context.commit('SET_ESTABELECIMENTO', data.data)
                     
                      resolve(data);
                  })
                  .catch(error => {
                      // console.log(error)
                      reject(error)
                  });
          });


  },

  async get_customer(context, value) {
    const AuthStr = 'Bearer ' + JSON.parse(localStorage.getItem('token_wise'))
    return new Promise((resolve, reject) => {
            
              return axios.get(url + "api/v1/customer/"+value,{
                      headers: {
                          'Authorization': AuthStr,
                          'Content-Type': 'application/json',
                      },
                  })
                .then(({ data }) => {
                      // context.commit('SET_CUSTOMER', data.data)
                      resolve(data);
                  })
                  .catch(error => {
                      // console.log(error)
                      reject(error)
                  });
          });


  },

  async gerarPix(context, value) {

    const AuthStr = value.apiKey

   let dados = {
                  valor: parseFloat(value.valor),
                  metodo: "pix",
                  data_vencimento: value.data,
                  data_processamento: "2022-07-04",
                  data_documentos: "2022-07-04",
                  pagador:{
                    nome_pagador: value.name,
                        registro_nacional: value.documento,
                        logradouro: "Rua central",
                        bairro: "CENTRO",
                        cidade: "Dourados",
                        uf: "MS",
                        cep: "79814030"
                    },
                    
                    instrucoes:"instrucao",
                    descricao:"descricao"
                }

    return new Promise((resolve, reject) => {
            
              return axios.post(url + "api/v1/orders", dados,{
                      headers: {
                          'x-api-key': AuthStr,
                          'Content-Type': 'application/json',
                      },
                  })
                .then((data ) => {
                      resolve(data);
                  })
                  .catch((error) => {
               
                    console.log(error.response)
                 
                      reject(error)
                  });
          });


  },

  async gerarBoleto(context, value) {

    const AuthStr = value.apiKey
    
   const dados = {
                  valor: parseFloat(value.valor),
                  metodo: "boleto",
                  data_vencimento: value.vencimento,
                  data_processamento: "2022-09-01",
                  data_documentos: "2022-09-01",
                  pagador:{
                        nome_pagador: value.name,
                        registro_nacional: value.documento,
                        logradouro: value.rua,
                        bairro: value.neighborhood,
                        cidade: value.city,
                        uf: value.uf,
                        cep: value.zipCode
                    },
                    numeroDiasLimiteRecebimento: 35,
                    instrucoes:"instrucao",
                    descricao:"descricao"
                }
              
            if(value.porcentagemJuros){
                  const  jurosMora = {
                      "tipo": parseInt(2),
                      "porcentagem": parseFloat(value.porcentagemJuros),
                      // "valor": 0
                  }
                    
              dados.jurosMora =jurosMora
                 
            }
            if(value.dataMulta){
                  let   multa = {
                    "tipo": parseInt(2),
                    "data": value.dataMulta,
                    "porcentagem": parseFloat(value.porcentagemMulta),
                    // "valor": 0
          
                }
                    
                dados.multa = multa
  
              }
            console.log(dados)

    return new Promise((resolve, reject) => {
            
              return axios.post(url + "api/v1/orders", dados,{
                      headers: {
                          'x-api-key': AuthStr,
                          'Content-Type': 'application/json',
                      },
                  })
                .then((data ) => {
                      resolve(data);
                  })
                  .catch((error) => {
               
                    console.log(error.response)
                 
                      reject(error)
                  });
          });


  },

  async getListOrder(context, value) {
    const AuthStr = 'Bearer ' + JSON.parse(localStorage.getItem('token_wise'))
    return new Promise((resolve, reject) => {
            
              return axios.get(url + "api/v1/orders?page=1&PerPage=100&sort=-createdAt&filter=establishmentId:"+value.id,{
                      headers: {
                          'Authorization': AuthStr,
                          'Content-Type': 'application/json',
                      },
                  })
                .then(({ data }) => {
                  console.log(data.data)
                      context.commit('SET_LISTA_ORDER', data.data)
                     
                      resolve(data);
                  })
                  .catch(error => {
                      // console.log(error)
                      reject(error)
                  });
          });


  },

  async buscarOrdens(context, value) {
    
    const page = "page=" + 1;
    const perPage = "&perPage=" + 5000;
    let between = "";
    if(value.data_inicio){
       between = "&between=" + value.tipoData + ":" + value.data_inicio +"_"+ value.data_fim
    }
    let status = "";
    let documento = "";
    let estabelecimento = "";

    let filter = ""

    if(value.status){
       status =  "status:" +value.status
    }

    if(value.documento){
      if(status){
        documento = ",document:"+value.documento
      }else{
        documento = "document:"+value.documento
      }
    
    }
    if(value.estabelecimento){
      if(status || documento){
        estabelecimento = ",establishmentId:"+value.estabelecimento
      }else{
        estabelecimento = "establishmentId:"+value.estabelecimento
      }
    }
    filter = "&filter="+status + documento + estabelecimento;
    const sort = "&sort=-" + value.tipoData
    const params = page+perPage+between+filter+sort;
    console.log(params)
    
    const AuthStr = 'Bearer ' + JSON.parse(localStorage.getItem('token_wise'))
    return new Promise((resolve, reject) => {
            
              return axios.get(url + "api/v1/orders?"+params,{
                      headers: {
                          'Authorization': AuthStr,
                          'Content-Type': 'application/json',
                      },
                  })
                .then(({ data }) => {
                  console.log(data.data)
                      context.commit('SET_LISTA_ORDER', data.data)
                     
                      resolve(data);
                  })
                  .catch(error => {
                      // console.log(error)
                      reject(error)
                  });
          });


  },

  async buscarSaldoDia(context, value) {
    
    const page = "page=" + 1;
    const perPage = "&perPage=" + 100;
    let between = "";
    if(value.data_inicio){
       between = "&between=" + value.tipoData + ":" + value.data_inicio +"_"+ value.data_fim
    }
    let status = "";
    let documento = "";
    let estabelecimento = "";

    let filter = ""

    if(value.status){
       status =  "status:" +value.status
    }

    if(value.documento){
      if(status){
        documento = ",document:"+value.documento
      }else{
        documento = "document:"+value.documento
      }
      
       
    }
    if(value.estabelecimento){
      if(status || documento){
        estabelecimento = ",establishmentId:"+value.estabelecimento
      }else{
        estabelecimento = "establishmentId:"+value.estabelecimento
      }
    }
    filter = "&filter="+status + documento + estabelecimento;
    const sort = "&sort=-" + value.tipoData
    const params = page+perPage+between+filter+sort;
    console.log(params)
    
    const AuthStr = 'Bearer ' + JSON.parse(localStorage.getItem('token_wise'))
    return new Promise((resolve, reject) => {
            
              return axios.get(url + "api/v1/orders?"+params,{
                      headers: {
                          'Authorization': AuthStr,
                          'Content-Type': 'application/json',
                      },
                  })
                .then(({ data }) => {
                  console.log(data.data)
                      context.commit('SET_SALDO_DIA', data.data)
                     
                      resolve(data);
                  })
                  .catch(error => {
                      // console.log(error)
                      reject(error)
                  });
          });


  },

  async getListMovimento(context, value) {
    const AuthStr = 'Bearer ' + JSON.parse(localStorage.getItem('token_wise'))
    return new Promise((resolve, reject) => {
            
              return axios.get(url + "api/v1/balance/"+value.id +"/history?between=createdAt:2023-10-01_2024-12-30&perPage=10",{
                      headers: {
                          'Authorization': AuthStr,
                          'Content-Type': 'application/json',
                      },
                  })
                .then(({ data }) => {
                  console.log(data.data)
                      context.commit('SET_LISTA_MOVIMENTACOES', data.data)
                     
                      resolve(data);
                  })
                  .catch(error => {
                      // console.log(error)
                      reject(error)
                  });
          });


  },

  },
  mutations: {
    SET_CONTAS_ESTABELECIMENTO(state, dados){
      state.contaEstabelecimento = dados;
    },
    SET_SALDO_ESTABELECIMENTO(state, dados){
      state.saldoEstabelecimento = dados;
    },

    SET_SALDO_EMPRESA(state, dados){
      state.saldoEmpresa = parseInt(dados);
    },
    SET_SALDO_HOJE(state, dados){
      state.saldoHoje = parseInt(dados);
    },
    SET_SALDO_MES(state, dados){
      state.saldoMes = parseInt(dados);
    },

    SET_ESTABELECIMENTOS(state, dados) {
     
      
      state.lista_estabelecimentos = dados;

    },
    SET_ESTABELECIMENTO(state, dados) {

      state.estabelecimento = dados;

    },
    SET_LISTA_ORDER(state, dados) {

      state.list_order = dados;

    },

    SET_LISTA_ENVIOS(state, dados) {

      state.list_envios =dados ;

    },

    SET_LISTA_MOVIMENTACOES(state, dados) {

      state.list_movimento = dados ;

    },


  },

  state: {
    contaEstabelecimento:[],
    saldoEstabelecimento:"",
    saldoEmpresa:"",
    saldoHoje:"",
    saldoMes:"",
    list_envios:[],
    list_order:[],
    lista_estabelecimentos:true,
    estabelecimento:{
      allEstablishment: {
        id: "",
        name: "",
        email: "",
        cnpj: "",
        apiKey: "",
        credentialsId: null
      },
      credential: {
          id: "",
          authToken: null,
          chavePix: "",
          numeroConvenio: "",
          pixAppKey: "",
          boletoAppKey: ""
      },
      fees: {
        id: "",
        boletoValue: "",
        boletoPercentage: "",
        pixPercentage: "",
        pixValue: "",

      }
    },
    list_movimento:[]
  },
}
